import auth from "@/middleware/auth";
import admin from "@/middleware/admin";

export const repeatRoutes = [
  {
    path: "/directories/repeat",
    name: "RepeatList",
    meta: { middleware: [auth, admin] },
    component: () =>
      import(/* webpackChunkName: "repeat" */ "./components/List"),
  },
];
